import { render, staticRenderFns } from "./gzBindPhoneSuccess.vue?vue&type=template&id=55728785&scoped=true&"
import script from "./gzBindPhoneSuccess.vue?vue&type=script&lang=js&"
export * from "./gzBindPhoneSuccess.vue?vue&type=script&lang=js&"
import style0 from "./gzBindPhoneSuccess.vue?vue&type=style&index=0&id=55728785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55728785",
  null
  
)

export default component.exports